import React from 'react';
import moment from 'moment-timezone';

const baseComparation = JSON.parse(`{
    "error": false,
    "message": "Lista de Contas A Pagar Carregada com sucesso.",
    "data": [
        {
            "ID": "7701",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "3020.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "154",
            "RECONCILIADO": "154",
            "DATA_RECONCILIADO": "2025-04-08 11:12:07",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "3020.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "11704",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-2300.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "200",
            "RECONCILIADO": "200",
            "DATA_RECONCILIADO": "2025-04-10 14:41:26",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "2300.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "11736",
            "CATEGORIA_ID": "100",
            "CATEGORIA": "TAXAS\/LICEN\u00c7AS DIVERSAS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-10 15:35:08",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "145.50",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "185",
            "RECONCILIADO": "185",
            "DATA_RECONCILIADO": "2025-04-10 15:35:33",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "8420.04",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "11737",
            "CATEGORIA_ID": "100",
            "CATEGORIA": "TAXAS\/LICEN\u00c7AS DIVERSAS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-10 15:36:05",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "145.50",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "187",
            "RECONCILIADO": "187",
            "DATA_RECONCILIADO": "2025-04-10 15:36:25",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "195.05",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "11746",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-10 17:08:19",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "144.45",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "358",
            "RECONCILIADO": "358",
            "DATA_RECONCILIADO": "2025-04-10 17:08:40",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "390.10",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "11747",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-10 17:09:22",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "144.45",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "360",
            "RECONCILIADO": "360",
            "DATA_RECONCILIADO": "2025-04-10 17:09:39",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "2509.00",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "16292",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-14 14:22:10",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "20.93",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "495",
            "RECONCILIADO": "495",
            "DATA_RECONCILIADO": "2025-04-14 14:22:38",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "634.66",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "16293",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-14 14:23:25",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "20.93",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "497",
            "RECONCILIADO": "497",
            "DATA_RECONCILIADO": "2025-04-14 14:27:43",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "1783.48",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "16813",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-8850.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "594",
            "RECONCILIADO": "594",
            "DATA_RECONCILIADO": "2025-04-15 10:51:40",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "8850.00",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "18709",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-15 20:00:15",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "550.90",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "687",
            "RECONCILIADO": "687",
            "DATA_RECONCILIADO": "2025-04-15 20:01:05",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "9052.77",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "18710",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-15 20:01:58",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "284.16",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "689",
            "RECONCILIADO": "689",
            "DATA_RECONCILIADO": "2025-04-15 20:02:19",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "284.16",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "19289",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-17 09:38:45",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "600.33",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "802",
            "RECONCILIADO": "802",
            "DATA_RECONCILIADO": "2025-04-17 09:39:46",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "3884.18",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "19290",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-17 09:39:17",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "600.33",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "804",
            "RECONCILIADO": "804",
            "DATA_RECONCILIADO": "2025-04-17 09:39:59",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "10143.17",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "19573",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-08 00:00:00",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "-6000.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "777",
            "RECONCILIADO": "777",
            "DATA_RECONCILIADO": "2025-04-17 11:33:02",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "6000.00",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "19692",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-17 11:53:20",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "261.64",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "812",
            "RECONCILIADO": "812",
            "DATA_RECONCILIADO": "2025-04-17 11:53:34",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "2271.29",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "19694",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-17 11:54:11",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "261.64",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "814",
            "RECONCILIADO": "814",
            "DATA_RECONCILIADO": "2025-04-17 11:54:33",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "8773.42",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "20634",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-707.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1000",
            "RECONCILIADO": "1000",
            "DATA_RECONCILIADO": "2025-04-17 17:08:40",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "707.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "20637",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-17 17:22:18",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "446.45",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1139",
            "RECONCILIADO": "1139",
            "DATA_RECONCILIADO": "2025-04-17 17:23:27",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "4221.80",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "20638",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-17 17:25:38",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "446.45",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1141",
            "RECONCILIADO": "1141",
            "DATA_RECONCILIADO": "2025-04-17 17:25:58",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "7251.29",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "21693",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-1315.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1053",
            "RECONCILIADO": "1053",
            "DATA_RECONCILIADO": "2025-04-22 14:50:21",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "1315.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "21806",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-512.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1070",
            "RECONCILIADO": "1070",
            "DATA_RECONCILIADO": "2025-04-22 15:45:43",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "512.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "21817",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-2220.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1131",
            "RECONCILIADO": "1131",
            "DATA_RECONCILIADO": "2025-04-22 16:23:05",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "2220.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "21846",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-23 11:18:37",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "226.35",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1276",
            "RECONCILIADO": "1276",
            "DATA_RECONCILIADO": "2025-04-23 11:19:22",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "802.01",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "21847",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-23 14:19:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "226.35",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1278",
            "RECONCILIADO": "1278",
            "DATA_RECONCILIADO": "2025-04-23 11:19:36",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "5495.29",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "22068",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-11 00:00:00",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "-200.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1414",
            "RECONCILIADO": "1414",
            "DATA_RECONCILIADO": "2025-04-23 11:55:47",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "200.00",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "22075",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-23 12:08:57",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "205.90",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1461",
            "RECONCILIADO": "1461",
            "DATA_RECONCILIADO": "2025-04-23 12:09:40",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "390.10",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "22076",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-23 15:09:20",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "205.90",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1463",
            "RECONCILIADO": "1463",
            "DATA_RECONCILIADO": "2025-04-23 12:09:54",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "3659.10",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "22688",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-23 14:05:40",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "28.01",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1646",
            "RECONCILIADO": "1646",
            "DATA_RECONCILIADO": "2025-04-23 14:07:16",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "205.95",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "22689",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-23 17:06:11",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "28.01",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1648",
            "RECONCILIADO": "1648",
            "DATA_RECONCILIADO": "2025-04-23 14:07:31",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "1566.02",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "25205",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-3700.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1684",
            "RECONCILIADO": "1684",
            "DATA_RECONCILIADO": "2025-04-24 14:12:51",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "3700.00",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "25244",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-24 14:56:04",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "302.29",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1781",
            "RECONCILIADO": "1781",
            "DATA_RECONCILIADO": "2025-04-24 14:56:47",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "596.05",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "25245",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-24 17:56:25",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "302.29",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1783",
            "RECONCILIADO": "1783",
            "DATA_RECONCILIADO": "2025-04-24 14:57:06",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "5530.36",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "25625",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-24 16:17:04",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "363.10",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1896",
            "RECONCILIADO": "1896",
            "DATA_RECONCILIADO": "2025-04-24 16:23:41",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "5643.57",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "25631",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-24 19:18:59",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "363.10",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1898",
            "RECONCILIADO": "1898",
            "DATA_RECONCILIADO": "2025-04-24 16:24:23",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "6457.22",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "26280",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-25 10:49:28",
            "DATA_VENCIMENTO": "2025-04-17",
            "DATA_PAGAMENTO": "2025-04-17 00:00:00",
            "PAGO": "S",
            "VALOR": "473.65",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1986",
            "RECONCILIADO": "1986",
            "DATA_RECONCILIADO": "2025-04-25 10:49:47",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "5466.35",
            "DATA_MOVIMENTACAO": "2025-04-17"
        },
        {
            "ID": "27425",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-26 09:26:26",
            "DATA_VENCIMENTO": "2025-04-22",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "S",
            "VALOR": "839.02",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2283",
            "RECONCILIADO": "2283",
            "DATA_RECONCILIADO": "2025-04-26 09:30:12",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "15136.69",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27426",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-26 09:28:23",
            "DATA_VENCIMENTO": "2025-04-22",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "S",
            "VALOR": "839.02",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2285",
            "RECONCILIADO": "2285",
            "DATA_RECONCILIADO": "2025-04-26 09:31:16",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "1075.26",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27433",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-22 00:00:00",
            "DATA_VENCIMENTO": "2025-04-22",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "S",
            "VALOR": "-12057.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2165",
            "RECONCILIADO": "2165",
            "DATA_RECONCILIADO": "2025-04-26 10:03:57",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "12057.00",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27661",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-23 00:00:00",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2409",
            "RECONCILIADO": "2409",
            "DATA_RECONCILIADO": "2025-04-26 11:15:07",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "27662",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-23 00:00:00",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2406",
            "RECONCILIADO": "2406",
            "DATA_RECONCILIADO": "2025-04-26 11:15:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "27664",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-23 00:00:00",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2403",
            "RECONCILIADO": "2403",
            "DATA_RECONCILIADO": "2025-04-26 11:16:09",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "27665",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-23 00:00:00",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2401",
            "RECONCILIADO": "2401",
            "DATA_RECONCILIADO": "2025-04-26 11:16:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "27666",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-23 00:00:00",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "-3.47",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2399",
            "RECONCILIADO": "2399",
            "DATA_RECONCILIADO": "2025-04-26 11:16:58",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "3.47",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "27667",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-23 00:00:00",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.62",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2397",
            "RECONCILIADO": "2397",
            "DATA_RECONCILIADO": "2025-04-26 11:17:27",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.62",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "27668",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-22 00:00:00",
            "DATA_VENCIMENTO": "2025-04-22",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "S",
            "VALOR": "-12057.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70171855 - RFW CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2289",
            "RECONCILIADO": "2289",
            "DATA_RECONCILIADO": "2025-04-26 11:17:47",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "12057.00",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27669",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-22 00:00:00",
            "DATA_VENCIMENTO": "2025-04-22",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2288",
            "RECONCILIADO": "2288",
            "DATA_RECONCILIADO": "2025-04-26 11:18:06",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27670",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-22 00:00:00",
            "DATA_VENCIMENTO": "2025-04-22",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "S",
            "VALOR": "-3.22",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2286",
            "RECONCILIADO": "2286",
            "DATA_RECONCILIADO": "2025-04-26 11:18:27",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "3.22",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27671",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-22 00:00:00",
            "DATA_VENCIMENTO": "2025-04-22",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "S",
            "VALOR": "-45.41",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2284",
            "RECONCILIADO": "2284",
            "DATA_RECONCILIADO": "2025-04-26 11:18:41",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "45.41",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27672",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-21 00:00:00",
            "DATA_VENCIMENTO": "2025-04-21",
            "DATA_PAGAMENTO": "2025-04-21 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2127",
            "RECONCILIADO": "2127",
            "DATA_RECONCILIADO": "2025-04-26 11:19:03",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-21"
        },
        {
            "ID": "27673",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-21 00:00:00",
            "DATA_VENCIMENTO": "2025-04-21",
            "DATA_PAGAMENTO": "2025-04-21 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2125",
            "RECONCILIADO": "2125",
            "DATA_RECONCILIADO": "2025-04-26 11:19:26",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-21"
        },
        {
            "ID": "27674",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-20 00:00:00",
            "DATA_VENCIMENTO": "2025-04-20",
            "DATA_PAGAMENTO": "2025-04-20 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2089",
            "RECONCILIADO": "2089",
            "DATA_RECONCILIADO": "2025-04-26 11:19:49",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-20"
        },
        {
            "ID": "27675",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-20 00:00:00",
            "DATA_VENCIMENTO": "2025-04-20",
            "DATA_PAGAMENTO": "2025-04-20 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.90",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2087",
            "RECONCILIADO": "2087",
            "DATA_RECONCILIADO": "2025-04-26 11:20:06",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.90",
            "DATA_MOVIMENTACAO": "2025-04-20"
        },
        {
            "ID": "27676",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-19 00:00:00",
            "DATA_VENCIMENTO": "2025-04-19",
            "DATA_PAGAMENTO": "2025-04-19 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2083",
            "RECONCILIADO": "2083",
            "DATA_RECONCILIADO": "2025-04-26 11:20:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-19"
        },
        {
            "ID": "27677",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-18 00:00:00",
            "DATA_VENCIMENTO": "2025-04-18",
            "DATA_PAGAMENTO": "2025-04-18 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2073",
            "RECONCILIADO": "2073",
            "DATA_RECONCILIADO": "2025-04-26 11:20:49",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-18"
        },
        {
            "ID": "27678",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-17 00:00:00",
            "DATA_VENCIMENTO": "2025-04-17",
            "DATA_PAGAMENTO": "2025-04-17 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1993",
            "RECONCILIADO": "1993",
            "DATA_RECONCILIADO": "2025-04-26 11:21:09",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-17"
        },
        {
            "ID": "27679",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-17 00:00:00",
            "DATA_VENCIMENTO": "2025-04-17",
            "DATA_PAGAMENTO": "2025-04-17 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1990",
            "RECONCILIADO": "1990",
            "DATA_RECONCILIADO": "2025-04-26 11:21:40",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-17"
        },
        {
            "ID": "27680",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-17 00:00:00",
            "DATA_VENCIMENTO": "2025-04-17",
            "DATA_PAGAMENTO": "2025-04-17 00:00:00",
            "PAGO": "S",
            "VALOR": "-16.39",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1987",
            "RECONCILIADO": "1987",
            "DATA_RECONCILIADO": "2025-04-26 11:22:13",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "16.39",
            "DATA_MOVIMENTACAO": "2025-04-17"
        },
        {
            "ID": "27681",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1916",
            "RECONCILIADO": "1916",
            "DATA_RECONCILIADO": "2025-04-26 11:22:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27682",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1914",
            "RECONCILIADO": "1914",
            "DATA_RECONCILIADO": "2025-04-26 11:22:52",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27684",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1912",
            "RECONCILIADO": "1912",
            "DATA_RECONCILIADO": "2025-04-26 11:25:41",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27685",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1910",
            "RECONCILIADO": "1910",
            "DATA_RECONCILIADO": "2025-04-26 11:26:02",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27686",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1908",
            "RECONCILIADO": "1908",
            "DATA_RECONCILIADO": "2025-04-26 11:26:25",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27687",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1906",
            "RECONCILIADO": "1906",
            "DATA_RECONCILIADO": "2025-04-26 11:26:46",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27688",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1901",
            "RECONCILIADO": "1901",
            "DATA_RECONCILIADO": "2025-04-26 11:27:08",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27689",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-19.37",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1899",
            "RECONCILIADO": "1899",
            "DATA_RECONCILIADO": "2025-04-26 11:27:26",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "19.37",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27690",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-16 00:00:00",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "S",
            "VALOR": "-16.93",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1897",
            "RECONCILIADO": "1897",
            "DATA_RECONCILIADO": "2025-04-26 11:27:45",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "16.93",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "27691",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1792",
            "RECONCILIADO": "1792",
            "DATA_RECONCILIADO": "2025-04-26 11:28:00",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "27692",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-3700.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70171855 - RFW CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1789",
            "RECONCILIADO": "1789",
            "DATA_RECONCILIADO": "2025-04-26 11:28:18",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "3700.00",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "27693",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1788",
            "RECONCILIADO": "1788",
            "DATA_RECONCILIADO": "2025-04-26 11:28:34",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "27694",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1786",
            "RECONCILIADO": "1786",
            "DATA_RECONCILIADO": "2025-04-26 11:28:51",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "27695",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-16.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1784",
            "RECONCILIADO": "1784",
            "DATA_RECONCILIADO": "2025-04-26 11:29:07",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "16.59",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "27696",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-1.78",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1782",
            "RECONCILIADO": "1782",
            "DATA_RECONCILIADO": "2025-04-26 11:29:26",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1.78",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "27697",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-15 00:00:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1780",
            "RECONCILIADO": "1780",
            "DATA_RECONCILIADO": "2025-04-26 11:29:43",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "27698",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-14 00:00:00",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1655",
            "RECONCILIADO": "1655",
            "DATA_RECONCILIADO": "2025-04-26 11:30:01",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "27699",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-14 00:00:00",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1653",
            "RECONCILIADO": "1653",
            "DATA_RECONCILIADO": "2025-04-26 11:30:26",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "27700",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-14 00:00:00",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1651",
            "RECONCILIADO": "1651",
            "DATA_RECONCILIADO": "2025-04-26 11:30:52",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "27701",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-14 00:00:00",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "-4.69",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1649",
            "RECONCILIADO": "1649",
            "DATA_RECONCILIADO": "2025-04-26 11:31:07",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4.69",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "27702",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-14 00:00:00",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.61",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1647",
            "RECONCILIADO": "1647",
            "DATA_RECONCILIADO": "2025-04-26 11:31:22",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.61",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "27703",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-14 00:00:00",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": "2025-04-14 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.90",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1645",
            "RECONCILIADO": "1645",
            "DATA_RECONCILIADO": "2025-04-26 11:31:38",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.90",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "27704",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-11 00:00:00",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1470",
            "RECONCILIADO": "1470",
            "DATA_RECONCILIADO": "2025-04-26 11:31:58",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "27705",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-11 00:00:00",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "-200.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70144092 - RTM CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1467",
            "RECONCILIADO": "1467",
            "DATA_RECONCILIADO": "2025-04-26 11:34:50",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "200.00",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "27706",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-11 00:00:00",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1466",
            "RECONCILIADO": "1466",
            "DATA_RECONCILIADO": "2025-04-26 11:35:08",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "27707",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-11 00:00:00",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "-10.97",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1464",
            "RECONCILIADO": "1464",
            "DATA_RECONCILIADO": "2025-04-26 11:35:29",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "10.97",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "27708",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-11 00:00:00",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "-1.17",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1462",
            "RECONCILIADO": "1462",
            "DATA_RECONCILIADO": "2025-04-26 11:35:46",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1.17",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "27709",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-10 00:00:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1292",
            "RECONCILIADO": "1292",
            "DATA_RECONCILIADO": "2025-04-26 11:35:59",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "27710",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-10 00:00:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1290",
            "RECONCILIADO": "1290",
            "DATA_RECONCILIADO": "2025-04-26 11:36:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "27711",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-10 00:00:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1288",
            "RECONCILIADO": "1288",
            "DATA_RECONCILIADO": "2025-04-26 11:36:33",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "27712",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-10 00:00:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1286",
            "RECONCILIADO": "1286",
            "DATA_RECONCILIADO": "2025-04-26 11:36:51",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "27713",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-10 00:00:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.60",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1281",
            "RECONCILIADO": "1281",
            "DATA_RECONCILIADO": "2025-04-26 11:37:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.60",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "27714",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-10 00:00:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "-16.48",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1279",
            "RECONCILIADO": "1279",
            "DATA_RECONCILIADO": "2025-04-26 11:37:30",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "16.48",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "27715",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-10 00:00:00",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "S",
            "VALOR": "-2.40",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1277",
            "RECONCILIADO": "1277",
            "DATA_RECONCILIADO": "2025-04-26 11:37:44",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2.40",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "27719",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1154",
            "RECONCILIADO": "1154",
            "DATA_RECONCILIADO": "2025-04-26 11:39:05",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27720",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-512.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70255930 - RTB CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1152",
            "RECONCILIADO": "1152",
            "DATA_RECONCILIADO": "2025-04-26 11:39:17",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "512.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27721",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-2220.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70183793 - RTC CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1151",
            "RECONCILIADO": "1151",
            "DATA_RECONCILIADO": "2025-04-26 11:39:27",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2220.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27722",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-1315.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70174339 - TR CLINICAS DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1150",
            "RECONCILIADO": "1150",
            "DATA_RECONCILIADO": "2025-04-26 11:39:36",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1315.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27723",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-707.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70183694 - RTR CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1149",
            "RECONCILIADO": "1149",
            "DATA_RECONCILIADO": "2025-04-26 11:39:49",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "707.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27724",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-1.15",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1148",
            "RECONCILIADO": "1148",
            "DATA_RECONCILIADO": "2025-04-26 11:40:03",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1.15",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27725",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1146",
            "RECONCILIADO": "1146",
            "DATA_RECONCILIADO": "2025-04-26 11:40:36",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27726",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1144",
            "RECONCILIADO": "1144",
            "DATA_RECONCILIADO": "2025-04-26 11:40:53",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27727",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-21.75",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1142",
            "RECONCILIADO": "1142",
            "DATA_RECONCILIADO": "2025-04-26 11:41:10",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "21.75",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27728",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-12.66",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1140",
            "RECONCILIADO": "1140",
            "DATA_RECONCILIADO": "2025-04-26 11:41:22",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "12.66",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "27729",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-08 00:00:00",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "-6000.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70174339 - TR CLINICAS DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "818",
            "RECONCILIADO": "818",
            "DATA_RECONCILIADO": "2025-04-26 11:41:35",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "6000.00",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "27730",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-08 00:00:00",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "817",
            "RECONCILIADO": "817",
            "DATA_RECONCILIADO": "2025-04-26 11:41:49",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "27731",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-08 00:00:00",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "-26.32",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "815",
            "RECONCILIADO": "815",
            "DATA_RECONCILIADO": "2025-04-26 11:42:05",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "26.32",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "27732",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-08 00:00:00",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "-6.81",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "813",
            "RECONCILIADO": "813",
            "DATA_RECONCILIADO": "2025-04-26 11:42:19",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "6.81",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "27733",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-07 00:00:00",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ Mesma Titul.",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "811",
            "RECONCILIADO": "811",
            "DATA_RECONCILIADO": "2025-04-26 11:42:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "27734",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-07 00:00:00",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "809",
            "RECONCILIADO": "809",
            "DATA_RECONCILIADO": "2025-04-26 11:42:52",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "27735",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-07 00:00:00",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "807",
            "RECONCILIADO": "807",
            "DATA_RECONCILIADO": "2025-04-26 11:43:08",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "27736",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-07 00:00:00",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "-30.42",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "805",
            "RECONCILIADO": "805",
            "DATA_RECONCILIADO": "2025-04-26 11:43:26",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "30.42",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "27737",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-07 00:00:00",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "-11.65",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "803",
            "RECONCILIADO": "803",
            "DATA_RECONCILIADO": "2025-04-26 11:43:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "11.65",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "27738",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.19",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "696",
            "RECONCILIADO": "696",
            "DATA_RECONCILIADO": "2025-04-26 11:43:59",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.19",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "27739",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "693",
            "RECONCILIADO": "693",
            "DATA_RECONCILIADO": "2025-04-26 11:44:20",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "27740",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-8850.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70171855 - RFW CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "691",
            "RECONCILIADO": "691",
            "DATA_RECONCILIADO": "2025-04-26 11:44:34",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "8850.00",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "27741",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.85",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "690",
            "RECONCILIADO": "690",
            "DATA_RECONCILIADO": "2025-04-26 11:44:47",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.85",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "27742",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-27.15",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "688",
            "RECONCILIADO": "688",
            "DATA_RECONCILIADO": "2025-04-26 11:45:01",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "27.15",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "27743",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "513",
            "RECONCILIADO": "513",
            "DATA_RECONCILIADO": "2025-04-26 11:45:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27744",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "511",
            "RECONCILIADO": "511",
            "DATA_RECONCILIADO": "2025-04-26 11:45:34",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27745",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "509",
            "RECONCILIADO": "509",
            "DATA_RECONCILIADO": "2025-04-26 11:45:55",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27746",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "507",
            "RECONCILIADO": "507",
            "DATA_RECONCILIADO": "2025-04-26 11:46:12",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27747",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "505",
            "RECONCILIADO": "505",
            "DATA_RECONCILIADO": "2025-04-26 11:46:29",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27748",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "503",
            "RECONCILIADO": "503",
            "DATA_RECONCILIADO": "2025-04-26 11:46:45",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27749",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "501",
            "RECONCILIADO": "501",
            "DATA_RECONCILIADO": "2025-04-26 11:47:01",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27750",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.35",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "498",
            "RECONCILIADO": "498",
            "DATA_RECONCILIADO": "2025-04-26 11:47:22",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.35",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27751",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-1.90",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "496",
            "RECONCILIADO": "496",
            "DATA_RECONCILIADO": "2025-04-26 11:47:36",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1.90",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27752",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-02 00:00:00",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "363",
            "RECONCILIADO": "363",
            "DATA_RECONCILIADO": "2025-04-26 11:47:56",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "27753",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-02 00:00:00",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "-7.52",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "361",
            "RECONCILIADO": "361",
            "DATA_RECONCILIADO": "2025-04-26 11:48:13",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "7.52",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "27754",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-02 00:00:00",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "-1.17",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "359",
            "RECONCILIADO": "359",
            "DATA_RECONCILIADO": "2025-04-26 11:48:27",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1.17",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "27755",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-02 00:00:00",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "-1.35",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "357",
            "RECONCILIADO": "357",
            "DATA_RECONCILIADO": "2025-04-26 11:48:42",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1.35",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "27756",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "196",
            "RECONCILIADO": "196",
            "DATA_RECONCILIADO": "2025-04-26 11:49:03",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27757",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-3020.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70190103 - RLM CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "194",
            "RECONCILIADO": "194",
            "DATA_RECONCILIADO": "2025-04-26 11:49:20",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "3020.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27758",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "193",
            "RECONCILIADO": "193",
            "DATA_RECONCILIADO": "2025-04-26 11:49:35",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27759",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "191",
            "RECONCILIADO": "191",
            "DATA_RECONCILIADO": "2025-04-26 11:50:04",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27760",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-2300.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70255930 - RTB CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "189",
            "RECONCILIADO": "189",
            "DATA_RECONCILIADO": "2025-04-26 11:50:17",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2300.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27761",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.58",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "188",
            "RECONCILIADO": "188",
            "DATA_RECONCILIADO": "2025-04-26 11:50:31",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.58",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27762",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-25.26",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "186",
            "RECONCILIADO": "186",
            "DATA_RECONCILIADO": "2025-04-26 11:50:46",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "25.26",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27763",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2675",
            "RECONCILIADO": "2675",
            "DATA_RECONCILIADO": "2025-04-26 11:53:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27764",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2673",
            "RECONCILIADO": "2673",
            "DATA_RECONCILIADO": "2025-04-26 11:53:43",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "10987",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "44.648.306 TALITA DE BRIDA AGUIAR",
            "FORNECEDOR_ID": "79",
            "DATA_CADASTRO": "2025-04-10 13:50:11",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "N",
            "VALOR": "1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "6kHSAvFHAoJ4hFZvB3qc",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "3",
            "DESCRICAO": "SEMANAL QUIRO TALITA DE BRIDA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2672",
            "RECONCILIADO": "2672",
            "DATA_RECONCILIADO": "2025-04-26 11:54:03",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27765",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2671",
            "RECONCILIADO": "2671",
            "DATA_RECONCILIADO": "2025-04-26 11:54:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "11087",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "23.221.201 CARLOS ARMANI JUNIOR",
            "FORNECEDOR_ID": "80",
            "DATA_CADASTRO": "2025-04-10 13:51:13",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "N",
            "VALOR": "1000.00",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "qPqQVA54MBOEkY1JVSRO",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "3",
            "DESCRICAO": "SEMANAL QUIRO CARLOS ARMANI",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2670",
            "RECONCILIADO": "2670",
            "DATA_RECONCILIADO": "2025-04-26 11:54:37",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1000.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27766",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2669",
            "RECONCILIADO": "2669",
            "DATA_RECONCILIADO": "2025-04-26 11:55:03",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "11187",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "58.500.934 ANGELO GUERREIRO BORGES DA SILVA",
            "FORNECEDOR_ID": "82",
            "DATA_CADASTRO": "2025-04-10 13:51:53",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "N",
            "VALOR": "1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "0Zqtyy0AFUhyjW5LM9Oi",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "3",
            "DESCRICAO": "SEMANAL QUIRO ANGELO GUERREIRO",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2668",
            "RECONCILIADO": "2668",
            "DATA_RECONCILIADO": "2025-04-26 11:55:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27767",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2667",
            "RECONCILIADO": "2667",
            "DATA_RECONCILIADO": "2025-04-26 11:55:46",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "11287",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "ISABELA SA ATHAYDE 47560306888",
            "FORNECEDOR_ID": "81",
            "DATA_CADASTRO": "2025-04-10 13:53:30",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "N",
            "VALOR": "2500.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "f6rQUzvudyFvuDkwEzWa",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "3",
            "DESCRICAO": "SEMANAL QUIRO ISABELA ATHAYDE",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2666",
            "RECONCILIADO": "2666",
            "DATA_RECONCILIADO": "2025-04-26 11:57:56",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2500.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27768",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2665",
            "RECONCILIADO": "2665",
            "DATA_RECONCILIADO": "2025-04-26 11:58:08",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27769",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-6.70",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2663",
            "RECONCILIADO": "2663",
            "DATA_RECONCILIADO": "2025-04-26 11:58:55",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "6.70",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27770",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2661",
            "RECONCILIADO": "2661",
            "DATA_RECONCILIADO": "2025-04-26 11:59:44",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27771",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-25 00:00:00",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "-1000.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2660",
            "RECONCILIADO": "2660",
            "DATA_RECONCILIADO": "2025-04-26 12:00:03",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1000.00",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "27772",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-24 00:00:00",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-24 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2539",
            "RECONCILIADO": "2539",
            "DATA_RECONCILIADO": "2025-04-26 12:00:16",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-24"
        },
        {
            "ID": "27773",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-24 00:00:00",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-24 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2537",
            "RECONCILIADO": "2537",
            "DATA_RECONCILIADO": "2025-04-26 12:00:28",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-24"
        },
        {
            "ID": "9550",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-09 13:44:05",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "N",
            "VALOR": "453.76",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "tFyxxSLjNh5FQQSzhBdO",
            "RECORRENCIA_TIPO": "D",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "15",
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2536",
            "RECONCILIADO": "2536",
            "DATA_RECONCILIADO": "2025-04-26 12:00:58",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-24"
        },
        {
            "ID": "27774",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-24 00:00:00",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-24 00:00:00",
            "PAGO": "S",
            "VALOR": "-17.94",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2535",
            "RECONCILIADO": "2535",
            "DATA_RECONCILIADO": "2025-04-26 12:01:11",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "17.94",
            "DATA_MOVIMENTACAO": "2025-04-24"
        },
        {
            "ID": "23904",
            "CATEGORIA_ID": "34",
            "CATEGORIA": "SOFTWARE RH\/SOLIDES",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "S\u00d3LIDES",
            "FORNECEDOR_ID": "128",
            "DATA_CADASTRO": "2025-04-23 14:51:32",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "N",
            "VALOR": "149.60",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "bl5GIs28FBdyD6DanqM0",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - S\u00d3LIDES E MAXFOLHA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2410",
            "RECONCILIADO": "2410",
            "DATA_RECONCILIADO": "2025-04-26 12:01:50",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "233.60",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "24105",
            "CATEGORIA_ID": "87",
            "CATEGORIA": "EMPRESA DE SEGURAN\u00c7A",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SEGURAN\u00c7A GOI\u00c2NIA ROADSAT",
            "FORNECEDOR_ID": "131",
            "DATA_CADASTRO": "2025-04-23 15:00:23",
            "DATA_VENCIMENTO": "2025-03-26",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "N",
            "VALOR": "424.23",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "xuKRYpoxshYfzezZsxd4",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SEGURAN\u00c7A ROADSAT",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2408",
            "RECONCILIADO": "2408",
            "DATA_RECONCILIADO": "2025-04-26 12:03:09",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "424.23",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "24004",
            "CATEGORIA_ID": "89",
            "CATEGORIA": "INTERNET\/TELEFONE FIXO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "VIVO Telef\u00f4nica Brasil S\/A",
            "FORNECEDOR_ID": "116",
            "DATA_CADASTRO": "2025-04-23 14:58:06",
            "DATA_VENCIMENTO": "2025-04-26",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "78.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "MKhdyDBGagI945CbXrmd",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "VIVO - FREDERICO",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2407",
            "RECONCILIADO": "2407",
            "DATA_RECONCILIADO": "2025-04-26 12:03:45",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "78.00",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "9544",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-09 13:44:05",
            "DATA_VENCIMENTO": "2025-04-17",
            "DATA_PAGAMENTO": "2025-04-17 00:00:00",
            "PAGO": "N",
            "VALOR": "453.76",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "tFyxxSLjNh5FQQSzhBdO",
            "RECORRENCIA_TIPO": "D",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "9",
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2400",
            "RECONCILIADO": "2400",
            "DATA_RECONCILIADO": "2025-04-26 12:04:47",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "21288",
            "CATEGORIA_ID": "82",
            "CATEGORIA": "CONTABILIDADE",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "GRAZIELA CONTABILIDADE",
            "FORNECEDOR_ID": "50",
            "DATA_CADASTRO": "2025-04-22 14:34:08",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "N",
            "VALOR": "1280.04",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": "30.04",
            "RECORRENCIA_ID": "eRftojaUuxfB4mBPb7RC",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "CONTABILIDADE GRAZIELA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "2290",
            "RECONCILIADO": "2290",
            "DATA_RECONCILIADO": "2025-04-26 12:05:31",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1280.04",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "374",
            "CATEGORIA_ID": "88",
            "CATEGORIA": "ENERGIA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "ENERGIA GOIANIA RTLFW",
            "FORNECEDOR_ID": "27",
            "DATA_CADASTRO": "2025-03-20 18:07:19",
            "DATA_VENCIMENTO": "2025-03-17",
            "DATA_PAGAMENTO": "2025-04-22 00:00:00",
            "PAGO": "N",
            "VALOR": "2824.88",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "Ju17mY0MxvX4mjjmF5AY",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "10",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "ENERGIA - GOI\u00c2NIA",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2287",
            "RECONCILIADO": "2287",
            "DATA_RECONCILIADO": "2025-04-26 12:05:56",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2824.88",
            "DATA_MOVIMENTACAO": "2025-04-22"
        },
        {
            "ID": "27776",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-20 00:00:00",
            "DATA_VENCIMENTO": "2025-04-20",
            "DATA_PAGAMENTO": "2025-04-20 00:00:00",
            "PAGO": "S",
            "VALOR": "-1000.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2088",
            "RECONCILIADO": "2088",
            "DATA_RECONCILIADO": "2025-04-26 12:08:04",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1000.00",
            "DATA_MOVIMENTACAO": "2025-04-20"
        },
        {
            "ID": "27777",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-18 00:00:00",
            "DATA_VENCIMENTO": "2025-04-18",
            "DATA_PAGAMENTO": "2025-04-18 00:00:00",
            "PAGO": "S",
            "VALOR": "-2000.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2072",
            "RECONCILIADO": "2072",
            "DATA_RECONCILIADO": "2025-04-26 12:08:23",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2000.00",
            "DATA_MOVIMENTACAO": "2025-04-18"
        },
        {
            "ID": "193",
            "CATEGORIA_ID": "73",
            "CATEGORIA": "\u00c1GUA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "\u00c1GUA - GOI\u00c2NIA - RTLFW",
            "FORNECEDOR_ID": "34",
            "DATA_CADASTRO": "2025-03-18 15:24:31",
            "DATA_VENCIMENTO": "2025-03-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "807.84",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "QdgobMreAlLtcHUSrF4g",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "10",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "\u00c1GUA - GOI\u00c2NIA",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "1917",
            "RECONCILIADO": "1917",
            "DATA_RECONCILIADO": "2025-04-26 12:11:06",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "807.84",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "19046",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "44.648.306 TALITA DE BRIDA AGUIAR",
            "FORNECEDOR_ID": "79",
            "DATA_CADASTRO": "2025-04-16 14:41:13",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "3525.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "Kam2cRtJXmI3D7UbUaij",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "MENSAL QUIRO TALITA DE BRIDA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1915",
            "RECONCILIADO": "1915",
            "DATA_RECONCILIADO": "2025-04-26 12:11:25",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "3525.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "19146",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "23.221.201 CARLOS ARMANI JUNIOR",
            "FORNECEDOR_ID": "80",
            "DATA_CADASTRO": "2025-04-16 14:42:03",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "5500.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "DQipfSaAbGXWKlWrxebv",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "MENSAL QUIRO CARLOS ARMANI",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1913",
            "RECONCILIADO": "1913",
            "DATA_RECONCILIADO": "2025-04-26 12:11:42",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5500.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "19246",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "ISABELA SA ATHAYDE 47560306888",
            "FORNECEDOR_ID": "81",
            "DATA_CADASTRO": "2025-04-16 14:42:52",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "2900.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "hdTUyEHeYUEp2wsF4szT",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "10",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "MENSAL QUIRO ISABELA ATHAYDE",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1911",
            "RECONCILIADO": "1911",
            "DATA_RECONCILIADO": "2025-04-26 12:12:01",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2900.00",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "19256",
            "CATEGORIA_ID": "9",
            "CATEGORIA": "REPASSE MASSOTERAPEUTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "MELISSA GIOVANA TENEOS MARTINI 04248253178",
            "FORNECEDOR_ID": "83",
            "DATA_CADASTRO": "2025-04-16 14:44:13",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "2680.25",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "Pd9D0vowxkxLdR6AEkBw",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "10",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "MENSAL MASSO MELISSA GIOVANA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1909",
            "RECONCILIADO": "1909",
            "DATA_RECONCILIADO": "2025-04-26 12:12:24",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2680.25",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "19266",
            "CATEGORIA_ID": "9",
            "CATEGORIA": "REPASSE MASSOTERAPEUTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "DHYESSYCA ANDRADE BATISTA 04193647145",
            "FORNECEDOR_ID": "84",
            "DATA_CADASTRO": "2025-04-16 14:45:04",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "4627.07",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "auEymqCH9cOBnv632qc5",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "10",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "MENSAL MASSO DHYESSICA ANDRADE",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1907",
            "RECONCILIADO": "1907",
            "DATA_RECONCILIADO": "2025-04-26 12:12:43",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4627.07",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "19276",
            "CATEGORIA_ID": "9",
            "CATEGORIA": "REPASSE MASSOTERAPEUTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "59.812.252 MARIA LUIZA DA SILVA SOUZA",
            "FORNECEDOR_ID": "122",
            "DATA_CADASTRO": "2025-04-16 14:50:44",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "1941.40",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "IAaoXIMNROzYBZXBzSQm",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "10",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "MENSAL QUIRO MARIA LUIZA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1905",
            "RECONCILIADO": "1905",
            "DATA_RECONCILIADO": "2025-04-26 12:13:13",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1941.40",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "9543",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-09 13:44:05",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": "2025-04-16 00:00:00",
            "PAGO": "N",
            "VALOR": "453.76",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "tFyxxSLjNh5FQQSzhBdO",
            "RECORRENCIA_TIPO": "D",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "8",
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1900",
            "RECONCILIADO": "1900",
            "DATA_RECONCILIADO": "2025-04-26 12:13:35",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-16"
        },
        {
            "ID": "18252",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "58.500.934 ANGELO GUERREIRO BORGES DA SILVA",
            "FORNECEDOR_ID": "82",
            "DATA_CADASTRO": "2025-04-15 14:54:48",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "N",
            "VALOR": "5592.37",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "3PPzFF43IDlZCvwZdghU",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "MENSAL ANGELO GUERREIRO",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1791",
            "RECONCILIADO": "1791",
            "DATA_RECONCILIADO": "2025-04-26 12:14:19",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5592.37",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "18251",
            "CATEGORIA_ID": "75",
            "CATEGORIA": "ALUGUEL DE IMPRESSORA\/M\u00c1QUINAS\/EQUIPAMENTOS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "IMPRESSORA GOIANIA TECPRINT COMERCIO E SERVI\u00c7OS LTDA",
            "FORNECEDOR_ID": "118",
            "DATA_CADASTRO": "2025-04-15 14:52:39",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "N",
            "VALOR": "247.20",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "7.20",
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "ALUGUEL IMPRESSORA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1790",
            "RECONCILIADO": "1790",
            "DATA_RECONCILIADO": "2025-04-26 12:15:07",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "247.20",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "9542",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-09 13:44:05",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-15 00:00:00",
            "PAGO": "N",
            "VALOR": "453.76",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "tFyxxSLjNh5FQQSzhBdO",
            "RECORRENCIA_TIPO": "D",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "7",
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1787",
            "RECONCILIADO": "1787",
            "DATA_RECONCILIADO": "2025-04-26 12:15:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-15"
        },
        {
            "ID": "24104",
            "CATEGORIA_ID": "89",
            "CATEGORIA": "INTERNET\/TELEFONE FIXO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "VIVO Telef\u00f4nica Brasil S\/A",
            "FORNECEDOR_ID": "116",
            "DATA_CADASTRO": "2025-04-23 14:58:58",
            "DATA_VENCIMENTO": "2025-03-26",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "N",
            "VALOR": "78.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "VIVO - FREDERICO",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1654",
            "RECONCILIADO": "1654",
            "DATA_RECONCILIADO": "2025-04-26 12:15:50",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "78.00",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "27778",
            "CATEGORIA_ID": "89",
            "CATEGORIA": "INTERNET\/TELEFONE FIXO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "OI - TELEFONIA\/INTERNET",
            "FORNECEDOR_ID": "125",
            "DATA_CADASTRO": "2025-04-26 12:18:19",
            "DATA_VENCIMENTO": "2025-03-24",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "179.84",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "OI - RTLFW\/SN",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1652",
            "RECONCILIADO": "1652",
            "DATA_RECONCILIADO": "2025-04-26 12:18:36",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "179.84",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "9541",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-09 13:44:05",
            "DATA_VENCIMENTO": "2025-04-14",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "453.76",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "tFyxxSLjNh5FQQSzhBdO",
            "RECORRENCIA_TIPO": "D",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "6",
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1650",
            "RECONCILIADO": "1650",
            "DATA_RECONCILIADO": "2025-04-26 12:19:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-14"
        },
        {
            "ID": "15120",
            "CATEGORIA_ID": "86",
            "CATEGORIA": "PRESTA\u00c7\u00c3O SERVI\u00c7OS LIMPEZA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "DIARISTAS",
            "FORNECEDOR_ID": "101",
            "DATA_CADASTRO": "2025-04-11 14:56:53",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "N",
            "VALOR": "830.00",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "DIARISTA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1469",
            "RECONCILIADO": "1469",
            "DATA_RECONCILIADO": "2025-04-26 12:20:41",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "830.00",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "15121",
            "CATEGORIA_ID": "82",
            "CATEGORIA": "CONTABILIDADE",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-11 14:57:30",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "N",
            "VALOR": "92.17",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "IgeyBuQlKHgzoJDPGqD4",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - CONTABILIDADE GRAZIELA SN\/SNS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1468",
            "RECONCILIADO": "1468",
            "DATA_RECONCILIADO": "2025-04-26 12:21:02",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "92.17",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "9538",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-09 13:44:05",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "N",
            "VALOR": "737.36",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "tFyxxSLjNh5FQQSzhBdO",
            "RECORRENCIA_TIPO": "D",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "3",
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1465",
            "RECONCILIADO": "1465",
            "DATA_RECONCILIADO": "2025-04-26 12:21:17",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "737.36",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "10985",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "44.648.306 TALITA DE BRIDA AGUIAR",
            "FORNECEDOR_ID": "79",
            "DATA_CADASTRO": "2025-04-10 13:50:11",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "N",
            "VALOR": "1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "6kHSAvFHAoJ4hFZvB3qc",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SEMANAL QUIRO TALITA DE BRIDA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1291",
            "RECONCILIADO": "1291",
            "DATA_RECONCILIADO": "2025-04-26 12:21:52",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "11085",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "23.221.201 CARLOS ARMANI JUNIOR",
            "FORNECEDOR_ID": "80",
            "DATA_CADASTRO": "2025-04-10 13:51:13",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "N",
            "VALOR": "1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "qPqQVA54MBOEkY1JVSRO",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SEMANAL QUIRO CARLOS ARMANI",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1289",
            "RECONCILIADO": "1289",
            "DATA_RECONCILIADO": "2025-04-26 12:22:11",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "11185",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "58.500.934 ANGELO GUERREIRO BORGES DA SILVA",
            "FORNECEDOR_ID": "82",
            "DATA_CADASTRO": "2025-04-10 13:51:53",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "N",
            "VALOR": "1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "0Zqtyy0AFUhyjW5LM9Oi",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SEMANAL QUIRO ANGELO GUERREIRO",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1287",
            "RECONCILIADO": "1287",
            "DATA_RECONCILIADO": "2025-04-26 12:22:28",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "11285",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "ISABELA SA ATHAYDE 47560306888",
            "FORNECEDOR_ID": "81",
            "DATA_CADASTRO": "2025-04-10 13:53:30",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "N",
            "VALOR": "2500.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "f6rQUzvudyFvuDkwEzWa",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SEMANAL QUIRO ISABELA ATHAYDE",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1285",
            "RECONCILIADO": "1285",
            "DATA_RECONCILIADO": "2025-04-26 12:22:43",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2500.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "11386",
            "CATEGORIA_ID": "34",
            "CATEGORIA": "SOFTWARE RH\/SOLIDES",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SISTEMA NF",
            "FORNECEDOR_ID": "99",
            "DATA_CADASTRO": "2025-04-10 13:58:28",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "N",
            "VALOR": "246.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "XK1f45QMvRJtCAjIXqcU",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "10",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SISTEMA PARA EMISSAO DE NFS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1284",
            "RECONCILIADO": "1284",
            "DATA_RECONCILIADO": "2025-04-26 12:23:13",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "246.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "11385",
            "CATEGORIA_ID": "94",
            "CATEGORIA": "MATERIAL APLICADO NA PRESTA\u00c7\u00c3O SERVI\u00c7OS QUIRO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "MERCADO LIVRE",
            "FORNECEDOR_ID": "98",
            "DATA_CADASTRO": "2025-04-10 13:56:25",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-10 00:00:00",
            "PAGO": "N",
            "VALOR": "220.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "OL\u00c9O PARA MASSO",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1283",
            "RECONCILIADO": "1283",
            "DATA_RECONCILIADO": "2025-04-26 12:24:07",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "220.00",
            "DATA_MOVIMENTACAO": "2025-04-10"
        },
        {
            "ID": "9737",
            "CATEGORIA_ID": "51",
            "CATEGORIA": "FOLHA TI",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SAL\u00c1RIOS FUNCION\u00c1RIOS",
            "FORNECEDOR_ID": "62",
            "DATA_CADASTRO": "2025-04-09 13:48:09",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "N",
            "VALOR": "549.05",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - FOLHA FELIPE ORSINI",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1155",
            "RECONCILIADO": "1155",
            "DATA_RECONCILIADO": "2025-04-26 13:42:05",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4569.05",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "9738",
            "CATEGORIA_ID": "22",
            "CATEGORIA": "PREMIA\u00c7\u00c3O GERENTE",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SAL\u00c1RIOS FUNCION\u00c1RIOS",
            "FORNECEDOR_ID": "62",
            "DATA_CADASTRO": "2025-04-09 13:50:03",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "N",
            "VALOR": "4020.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - PR\u00caMIO FUNCION\u00c1RIOS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1155",
            "RECONCILIADO": "1155",
            "DATA_RECONCILIADO": "2025-04-26 13:42:05",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4569.05",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "9636",
            "CATEGORIA_ID": "127",
            "CATEGORIA": "PREMIA\u00c7\u00c3O RENATO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "RENATO CORREIA",
            "FORNECEDOR_ID": "48",
            "DATA_CADASTRO": "2025-04-09 13:45:34",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "N",
            "VALOR": "800.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "PR\u00caMIO RENATO",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1153",
            "RECONCILIADO": "1153",
            "DATA_RECONCILIADO": "2025-04-26 13:42:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1808.91",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "9637",
            "CATEGORIA_ID": "128",
            "CATEGORIA": "PR\u00d3-LABORE RENATO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "RENATO CORREIA",
            "FORNECEDOR_ID": "48",
            "DATA_CADASTRO": "2025-04-09 13:47:01",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "N",
            "VALOR": "1008.91",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "WvSrzONKnz1hMhePJkAE",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SEMANAL RENATO CORREIA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1153",
            "RECONCILIADO": "1153",
            "DATA_RECONCILIADO": "2025-04-26 13:42:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1808.91",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "9536",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-09 13:44:05",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "N",
            "VALOR": "907.52",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "tFyxxSLjNh5FQQSzhBdO",
            "RECORRENCIA_TIPO": "D",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1145",
            "RECONCILIADO": "1145",
            "DATA_RECONCILIADO": "2025-04-26 13:42:49",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "907.52",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "7933",
            "CATEGORIA_ID": "23",
            "CATEGORIA": "PREMIA\u00c7\u00c3O MARKETING",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SAL\u00c1RIOS FUNCION\u00c1RIOS",
            "FORNECEDOR_ID": "62",
            "DATA_CADASTRO": "2025-04-08 14:59:38",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "N",
            "VALOR": "1770.77",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - PR\u00caMIO MKT",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "819",
            "RECONCILIADO": "819",
            "DATA_RECONCILIADO": "2025-04-26 13:43:38",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4601.84",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "7934",
            "CATEGORIA_ID": "19",
            "CATEGORIA": "PREMIA\u00c7\u00c3O ASSISTENTE",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SAL\u00c1RIOS FUNCION\u00c1RIOS",
            "FORNECEDOR_ID": "62",
            "DATA_CADASTRO": "2025-04-08 15:00:10",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "N",
            "VALOR": "1710.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - PR\u00caMIO FUNCION\u00c1RIOS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "819",
            "RECONCILIADO": "819",
            "DATA_RECONCILIADO": "2025-04-26 13:43:38",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4601.84",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "7935",
            "CATEGORIA_ID": "65",
            "CATEGORIA": "MARKETING SAL\u00c1RIO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SAL\u00c1RIOS FUNCION\u00c1RIOS",
            "FORNECEDOR_ID": "62",
            "DATA_CADASTRO": "2025-04-08 15:01:05",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "N",
            "VALOR": "1121.07",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "pHzUiSWBrhocG9Koq5nO",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - SAL\u00c1RIO MARKETING",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "819",
            "RECONCILIADO": "819",
            "DATA_RECONCILIADO": "2025-04-26 13:43:38",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4601.84",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "7932",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-08 14:58:59",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "N",
            "VALOR": "453.76",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "816",
            "RECONCILIADO": "816",
            "DATA_RECONCILIADO": "2025-04-26 13:43:55",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "27779",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "RTLFW CLINICA DE QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "96",
            "DATA_CADASTRO": "2025-04-07 00:00:00",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": "2025-04-07 00:00:00",
            "PAGO": "S",
            "VALOR": "-1500.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "RTLFW - ROBO MKT CART\u00c3O",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "810",
            "RECONCILIADO": "810",
            "DATA_RECONCILIADO": "2025-04-26 13:45:08",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1500.00",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "6591",
            "CATEGORIA_ID": "93",
            "CATEGORIA": "MATERIAL DE LIMPEZA\/HIGIENE",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "MATERIAIS LIMPEZA GOIANIA",
            "FORNECEDOR_ID": "63",
            "DATA_CADASTRO": "2025-04-07 15:55:07",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "423.05",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "MATERIAL DE LIMPEZA ",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "806",
            "RECONCILIADO": "806",
            "DATA_RECONCILIADO": "2025-04-26 13:46:01",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "423.05",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "27780",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-283.60",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "692",
            "RECONCILIADO": "692",
            "DATA_RECONCILIADO": "2025-04-26 13:46:22",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "283.60",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "6391",
            "CATEGORIA_ID": "56",
            "CATEGORIA": "FOLHA COMERCIAL",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SN QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "64",
            "DATA_CADASTRO": "2025-04-07 15:52:04",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "12124.64",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "Sbf8NVAHizdCUXq9IVwn",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SN - SAL\u00c1RIO FUNCION\u00c1RIOS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "808",
            "RECONCILIADO": "808",
            "DATA_RECONCILIADO": "2025-04-26 13:48:24",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "12622.48",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "6491",
            "CATEGORIA_ID": "41",
            "CATEGORIA": "FOLHA FINANCEIRO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SN QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "64",
            "DATA_CADASTRO": "2025-04-07 15:52:38",
            "DATA_VENCIMENTO": "2025-04-07",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "497.84",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "nhyRBAqWJ2Y6UtvYy645",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SN - SAL\u00c1RIO ADM",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "808",
            "RECONCILIADO": "808",
            "DATA_RECONCILIADO": "2025-04-26 13:48:24",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "12622.48",
            "DATA_MOVIMENTACAO": "2025-04-07"
        },
        {
            "ID": "27781",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-453.76",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "190",
            "RECONCILIADO": "190",
            "DATA_RECONCILIADO": "2025-04-26 13:48:57",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27788",
            "CATEGORIA_ID": "91",
            "CATEGORIA": "LAVANDERIA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "LAVANDERIA - RTLFW",
            "FORNECEDOR_ID": "134",
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-315.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "LAVANDERIA",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "195",
            "RECONCILIADO": "195",
            "DATA_RECONCILIADO": "2025-04-26 13:55:08",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "315.00",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "27793",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-02 00:00:00",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "-453.76",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "362",
            "RECONCILIADO": "362",
            "DATA_RECONCILIADO": "2025-04-26 13:56:41",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "453.76",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "27794",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-498.99",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "500",
            "RECONCILIADO": "500",
            "DATA_RECONCILIADO": "2025-04-26 13:56:58",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "498.99",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27795",
            "CATEGORIA_ID": "106",
            "CATEGORIA": "MATERIAL GR\u00c1FICO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "GRAFICA RTLFW",
            "FORNECEDOR_ID": "135",
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-1880.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "GRAFICA",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "502",
            "RECONCILIADO": "502",
            "DATA_RECONCILIADO": "2025-04-26 13:58:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1880.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27797",
            "CATEGORIA_ID": "34",
            "CATEGORIA": "SOFTWARE RH\/SOLIDES",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": " Autentique Ltda ",
            "FORNECEDOR_ID": "136",
            "DATA_CADASTRO": "2025-04-26 14:00:55",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "99.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "ZiOeTICgyzkFcD1DeAzR",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "AUTENTIQUE - SOFTWARE ASSINATURA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "504",
            "RECONCILIADO": "504",
            "DATA_RECONCILIADO": "2025-04-26 14:01:43",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "99.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27899",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "ISABELA SA ATHAYDE 47560306888",
            "FORNECEDOR_ID": "81",
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-2500.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SEMANAL QUIRO ISABELA SA ATHAYDE 47560306888",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "506",
            "RECONCILIADO": "506",
            "DATA_RECONCILIADO": "2025-04-26 14:02:04",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "2500.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27903",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "23.221.201 CARLOS ARMANI JUNIOR",
            "FORNECEDOR_ID": "80",
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SEMANAL QUIRO CARLOS ARMANI JUNIOR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "508",
            "RECONCILIADO": "508",
            "DATA_RECONCILIADO": "2025-04-26 14:03:18",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27910",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "58.500.934 ANGELO GUERREIRO BORGES DA SILVA",
            "FORNECEDOR_ID": "82",
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SEMANAL QUIRO ANGELO GUERREIRO B...",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "510",
            "RECONCILIADO": "510",
            "DATA_RECONCILIADO": "2025-04-26 14:05:04",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27914",
            "CATEGORIA_ID": "8",
            "CATEGORIA": "REPASSE QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "44.648.306 TALITA DE BRIDA AGUIAR",
            "FORNECEDOR_ID": "79",
            "DATA_CADASTRO": "2025-04-03 00:00:00",
            "DATA_VENCIMENTO": "2025-04-03",
            "DATA_PAGAMENTO": "2025-04-03 00:00:00",
            "PAGO": "S",
            "VALOR": "-1250.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SEMANAL QUIRO TALITA DE BRIDA AGUIAR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "512",
            "RECONCILIADO": "512",
            "DATA_RECONCILIADO": "2025-04-26 14:06:09",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1250.00",
            "DATA_MOVIMENTACAO": "2025-04-03"
        },
        {
            "ID": "27915",
            "CATEGORIA_ID": "38",
            "CATEGORIA": "VALE REFEI\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-180.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - VA LAYZA DOS SANTOS",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "694",
            "RECONCILIADO": "694",
            "DATA_RECONCILIADO": "2025-04-26 14:07:00",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "180.00",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "27916",
            "CATEGORIA_ID": "138",
            "CATEGORIA": "EMPR\u00c9STIMO TERCEIROS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "EMPR\u00c9STIMO AMANDA AM\u00c9LIA ",
            "FORNECEDOR_ID": "112",
            "DATA_CADASTRO": "2025-04-26 14:09:36",
            "DATA_VENCIMENTO": "2025-03-28",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "833.35",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "53Gyq8cFF2hoPwzVasNB",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "88",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "AMANDA - EMPREST RENATO VENDA DE COTAS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "192",
            "RECONCILIADO": "192",
            "DATA_RECONCILIADO": "2025-04-26 14:09:55",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "833.35",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "28004",
            "CATEGORIA_ID": "96",
            "CATEGORIA": "TERCEIRIZA\u00c7\u00c3O SERVI\u00c7OS SN\/SNS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TERCEIRIZA\u00c7\u00c3O SIRLEY",
            "FORNECEDOR_ID": "105",
            "DATA_CADASTRO": "2025-04-26 14:13:00",
            "DATA_VENCIMENTO": "2025-03-26",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "425.40",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "U8V84d20Za4ew6mj8bs2",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - TERCEIRIZA\u00c7\u00c3O DE SERVI\u00c7OS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "364",
            "RECONCILIADO": "364",
            "DATA_RECONCILIADO": "2025-04-26 14:14:43",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "789.12",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "28104",
            "CATEGORIA_ID": "64",
            "CATEGORIA": "MARKETING RESCIS\u00c3O\/FGTS RESCIS\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-26 14:13:45",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "N",
            "VALOR": "363.72",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - RESCIS\u00c3O MYLENA E VICTOR",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "364",
            "RECONCILIADO": "364",
            "DATA_RECONCILIADO": "2025-04-26 14:14:43",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "789.12",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "28105",
            "CATEGORIA_ID": "72",
            "CATEGORIA": "ADVOGADO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-26 14:15:48",
            "DATA_VENCIMENTO": "2025-03-25",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "381.09",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "Xzlx4tVFMex070WdLbgv",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - ADVOGADOS - KLIPPEL & WILRICH",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "197",
            "RECONCILIADO": "197",
            "DATA_RECONCILIADO": "2025-04-26 14:18:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "799.21",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "28205",
            "CATEGORIA_ID": "119",
            "CATEGORIA": "MANUTEN\u00c7\u00c3O CL\u00cdNICA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-26 14:16:46",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "N",
            "VALOR": "276.51",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - OBRA ADM",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "197",
            "RECONCILIADO": "197",
            "DATA_RECONCILIADO": "2025-04-26 14:18:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "799.21",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "28206",
            "CATEGORIA_ID": "68",
            "CATEGORIA": "SERVI\u00c7OS GERAIS F\u00c9RIAS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-26 14:17:26",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "N",
            "VALOR": "81.61",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - F\u00c9RIAS IRENE",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "197",
            "RECONCILIADO": "197",
            "DATA_RECONCILIADO": "2025-04-26 14:18:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "799.21",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "28207",
            "CATEGORIA_ID": "38",
            "CATEGORIA": "VALE REFEI\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-26 14:18:11",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "N",
            "VALOR": "60.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SNS - VA LAYZA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "197",
            "RECONCILIADO": "197",
            "DATA_RECONCILIADO": "2025-04-26 14:18:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "799.21",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "29266",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-28 10:56:45",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "34.99",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2398",
            "RECONCILIADO": "2398",
            "DATA_RECONCILIADO": "2025-04-28 10:57:09",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "1158.01",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "29467",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-28 12:15:52",
            "DATA_VENCIMENTO": "2025-04-24",
            "DATA_PAGAMENTO": "2025-04-24 00:00:00",
            "PAGO": "S",
            "VALOR": "600.77",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2534",
            "RECONCILIADO": "2534",
            "DATA_RECONCILIADO": "2025-04-28 12:16:22",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "5980.23",
            "DATA_MOVIMENTACAO": "2025-04-24"
        },
        {
            "ID": "29803",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-04-28 14:41:34",
            "DATA_VENCIMENTO": "2025-04-25",
            "DATA_PAGAMENTO": "2025-04-25 00:00:00",
            "PAGO": "S",
            "VALOR": "149.62",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2662",
            "RECONCILIADO": "2662",
            "DATA_RECONCILIADO": "2025-04-28 14:41:59",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "2235.38",
            "DATA_MOVIMENTACAO": "2025-04-25"
        },
        {
            "ID": "33448",
            "CATEGORIA_ID": "40",
            "CATEGORIA": "FOLHA DIRETOR QUIROPRAXISTA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "FILIPE DE OLIVEIRA GONCALVES",
            "FORNECEDOR_ID": "51",
            "DATA_CADASTRO": "2025-04-29 14:49:00",
            "DATA_VENCIMENTO": "2025-04-15",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "N",
            "VALOR": "1430.58",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "2MOna5RRKh9RwUXUjP1G",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "PREST SERV FILIPE OLIVEIRA DIRETOR",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3124",
            "RECONCILIADO": "3124",
            "DATA_RECONCILIADO": "2025-05-03 11:23:29",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1430.58",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "29810",
            "CATEGORIA_ID": "135",
            "CATEGORIA": "A\u00c7\u00d5ES\/CUSTAS JUDICIAIS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "A\u00c7\u00c3O ANDREI LOPES",
            "FORNECEDOR_ID": "52",
            "DATA_CADASTRO": "2025-04-28 16:11:24",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "N",
            "VALOR": "1169.85",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "IJNNpUlGGd2ORSBMPYKt",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "5",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "A\u00c7\u00c3O ANDREI LOPES",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3067",
            "RECONCILIADO": "3067",
            "DATA_RECONCILIADO": "2025-05-03 11:24:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1169.85",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "29815",
            "CATEGORIA_ID": "128",
            "CATEGORIA": "PR\u00d3-LABORE RENATO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "RENATO CORREIA",
            "FORNECEDOR_ID": "48",
            "DATA_CADASTRO": "2025-04-28 16:12:51",
            "DATA_VENCIMENTO": "2025-03-19",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "N",
            "VALOR": "797.63",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "SEMANAL RENATO CORREIA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3065",
            "RECONCILIADO": "3065",
            "DATA_RECONCILIADO": "2025-05-03 11:25:12",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1597.63",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "29336",
            "CATEGORIA_ID": "89",
            "CATEGORIA": "INTERNET\/TELEFONE FIXO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "CLARO",
            "FORNECEDOR_ID": "47",
            "DATA_CADASTRO": "2025-04-28 11:43:24",
            "DATA_VENCIMENTO": "2025-04-10",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "N",
            "VALOR": "329.58",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "cLmGl9k3FxlWPSPQkL4q",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "CLARO - TITULAR RTLFW",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3053",
            "RECONCILIADO": "3053",
            "DATA_RECONCILIADO": "2025-05-03 11:28:44",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "329.58",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "27917",
            "CATEGORIA_ID": "138",
            "CATEGORIA": "EMPR\u00c9STIMO TERCEIROS",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "EMPR\u00c9STIMO AMANDA AM\u00c9LIA ",
            "FORNECEDOR_ID": "112",
            "DATA_CADASTRO": "2025-04-26 14:09:36",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "N",
            "VALOR": "833.35",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "53Gyq8cFF2hoPwzVasNB",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "88",
            "RECORRENCIA_PARCELA": "2",
            "DESCRICAO": "AMANDA - EMPREST RENATO VENDA DE COTAS",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3058",
            "RECONCILIADO": "3058",
            "DATA_RECONCILIADO": "2025-05-03 11:29:10",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "833.35",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "33648",
            "CATEGORIA_ID": "152",
            "CATEGORIA": "TRANSPORTE CLINICA ",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-29 14:50:50",
            "DATA_VENCIMENTO": "2025-04-26",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "N",
            "VALOR": "903.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "DZ657fv8f5tEWpijZtKn",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - TRANSPORTE CLINICA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3126",
            "RECONCILIADO": "3126",
            "DATA_RECONCILIADO": "2025-05-03 11:29:50",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1119.78",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "33748",
            "CATEGORIA_ID": "153",
            "CATEGORIA": "FINANCEIRO TRANSPORTE",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-29 14:51:23",
            "DATA_VENCIMENTO": "2025-04-26",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "N",
            "VALOR": "14.39",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "bGITtCkbemHRixichWyT",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - TRANSPORTE ADM",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3126",
            "RECONCILIADO": "3126",
            "DATA_RECONCILIADO": "2025-05-03 11:29:50",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1119.78",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "9638",
            "CATEGORIA_ID": "128",
            "CATEGORIA": "PR\u00d3-LABORE RENATO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "RENATO CORREIA",
            "FORNECEDOR_ID": "48",
            "DATA_CADASTRO": "2025-04-09 13:47:02",
            "DATA_VENCIMENTO": "2025-04-16",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "797.63",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "WvSrzONKnz1hMhePJkAE",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "2",
            "DESCRICAO": "SEMANAL RENATO CORREIA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1992",
            "RECONCILIADO": "1992",
            "DATA_RECONCILIADO": "2025-05-03 11:35:25",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1000.00",
            "DATA_MOVIMENTACAO": "2025-04-17"
        },
        {
            "ID": "9639",
            "CATEGORIA_ID": "128",
            "CATEGORIA": "PR\u00d3-LABORE RENATO",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "RENATO CORREIA",
            "FORNECEDOR_ID": "48",
            "DATA_CADASTRO": "2025-04-09 13:47:02",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": null,
            "PAGO": "N",
            "VALOR": "202.37",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "WvSrzONKnz1hMhePJkAE",
            "RECORRENCIA_TIPO": "W",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "3",
            "DESCRICAO": "SEMANAL RENATO CORREIA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "1992",
            "RECONCILIADO": "1992",
            "DATA_RECONCILIADO": "2025-05-03 11:35:25",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1000.00",
            "DATA_MOVIMENTACAO": "2025-04-17"
        },
        {
            "ID": "42042",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-1300.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "2896",
            "RECONCILIADO": "2896",
            "DATA_RECONCILIADO": "2025-05-02 16:56:31",
            "CONCILIADO_POR": "analistaemilene",
            "VALOR_CONCILIADO": "1300.00",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42058",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-05-02 17:21:24",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "203.07",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3049",
            "RECONCILIADO": "3049",
            "DATA_RECONCILIADO": "2025-05-02 17:22:24",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "3383.93",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42064",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-05-02 17:28:56",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "340.71",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3119",
            "RECONCILIADO": "3119",
            "DATA_RECONCILIADO": "2025-05-02 17:29:17",
            "CONCILIADO_POR": "analistaemilene",
            "VALOR_CONCILIADO": "4229.29",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42089",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-1845.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3247",
            "RECONCILIADO": "3247",
            "DATA_RECONCILIADO": "2025-05-02 18:12:08",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "1845.00",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42090",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-4550.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3243",
            "RECONCILIADO": "3243",
            "DATA_RECONCILIADO": "2025-05-02 18:12:23",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "4550.00",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42136",
            "CATEGORIA_ID": "27",
            "CATEGORIA": "CART\u00c3O TAXA\/JURO DE ANTECIPA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "TAXAS",
            "FORNECEDOR_ID": "59",
            "DATA_CADASTRO": "2025-05-02 18:42:32",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "240.52",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "NULL",
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "TAXA VALORI ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3269",
            "RECONCILIADO": "3269",
            "DATA_RECONCILIADO": "2025-05-02 18:42:55",
            "CONCILIADO_POR": "assistemilly",
            "VALOR_CONCILIADO": "3815.48",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42320",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-1845.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70183793 - RTC CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3281",
            "RECONCILIADO": "3281",
            "DATA_RECONCILIADO": "2025-05-03 11:19:48",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1845.00",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "39203",
            "CATEGORIA_ID": "159",
            "CATEGORIA": "ALIMENTA\u00c7\u00c3O CLINICA ",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-30 14:39:30",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "N",
            "VALOR": "1080.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "dg696DgpUkc1G7oYnST8",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - ALIMENTA\u00c7\u00c3O CLINICA",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3280",
            "RECONCILIADO": "3280",
            "DATA_RECONCILIADO": "2025-05-03 11:20:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1359.45",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "39303",
            "CATEGORIA_ID": "160",
            "CATEGORIA": "FINANCEIRO ALIMENTA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-30 14:42:57",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "N",
            "VALOR": "108.25",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "OlAGgjendJcqZbn8EwBJ",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - ALIMENTA\u00c7\u00c3O ADM",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3280",
            "RECONCILIADO": "3280",
            "DATA_RECONCILIADO": "2025-05-03 11:20:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1359.45",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "39403",
            "CATEGORIA_ID": "163",
            "CATEGORIA": "MARKETING ALIMENTA\u00c7\u00c3O",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-30 14:43:31",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "N",
            "VALOR": "171.20",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": "7LKKP4N22JrtNvVxq0B2",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - ALIMENTA\u00c7\u00c3O MKT",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3280",
            "RECONCILIADO": "3280",
            "DATA_RECONCILIADO": "2025-05-03 11:20:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1359.45",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42321",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-4550.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70183793 - RTC CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3279",
            "RECONCILIADO": "3279",
            "DATA_RECONCILIADO": "2025-05-03 11:20:24",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4550.00",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42322",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-7.20",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3278",
            "RECONCILIADO": "3278",
            "DATA_RECONCILIADO": "2025-05-03 11:20:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "7.20",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42323",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-7.20",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3276",
            "RECONCILIADO": "3276",
            "DATA_RECONCILIADO": "2025-05-03 11:20:39",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "7.20",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42324",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3274",
            "RECONCILIADO": "3274",
            "DATA_RECONCILIADO": "2025-05-03 11:20:50",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42325",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3272",
            "RECONCILIADO": "3272",
            "DATA_RECONCILIADO": "2025-05-03 11:20:57",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42326",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-11.44",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3270",
            "RECONCILIADO": "3270",
            "DATA_RECONCILIADO": "2025-05-03 11:21:05",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "11.44",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42327",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3268",
            "RECONCILIADO": "3268",
            "DATA_RECONCILIADO": "2025-05-03 11:21:15",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "42328",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3128",
            "RECONCILIADO": "3128",
            "DATA_RECONCILIADO": "2025-05-03 11:21:21",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42329",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-890.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3127",
            "RECONCILIADO": "3127",
            "DATA_RECONCILIADO": "2025-05-03 11:21:36",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "890.00",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42330",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3125",
            "RECONCILIADO": "3125",
            "DATA_RECONCILIADO": "2025-05-03 11:23:12",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42331",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-1300.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "D\u00e9bito Transfer\u00eancia 70171855 - RFW CLINICA DE QUIROP",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3123",
            "RECONCILIADO": "3123",
            "DATA_RECONCILIADO": "2025-05-03 11:23:35",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1300.00",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42332",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-0.59",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3122",
            "RECONCILIADO": "3122",
            "DATA_RECONCILIADO": "2025-05-03 11:23:42",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "0.59",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42333",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-12.68",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3120",
            "RECONCILIADO": "3120",
            "DATA_RECONCILIADO": "2025-05-03 11:23:48",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "12.68",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42334",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3068",
            "RECONCILIADO": "3068",
            "DATA_RECONCILIADO": "2025-05-03 11:23:55",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42335",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3066",
            "RECONCILIADO": "3066",
            "DATA_RECONCILIADO": "2025-05-03 11:24:22",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42336",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3063",
            "RECONCILIADO": "3063",
            "DATA_RECONCILIADO": "2025-05-03 11:26:00",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42337",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3061",
            "RECONCILIADO": "3061",
            "DATA_RECONCILIADO": "2025-05-03 11:26:33",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42338",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PF",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3059",
            "RECONCILIADO": "3059",
            "DATA_RECONCILIADO": "2025-05-03 11:27:16",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42339",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ Mesma Titul.",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3048",
            "RECONCILIADO": "3048",
            "DATA_RECONCILIADO": "2025-05-03 11:27:58",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42340",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-10.15",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3050",
            "RECONCILIADO": "3050",
            "DATA_RECONCILIADO": "2025-05-03 11:28:05",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "10.15",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42341",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-400.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "FACEBOOK",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3051",
            "RECONCILIADO": "3051",
            "DATA_RECONCILIADO": "2025-05-03 11:28:19",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "400.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42342",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3052",
            "RECONCILIADO": "3052",
            "DATA_RECONCILIADO": "2025-05-03 11:28:26",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42343",
            "CATEGORIA_ID": "99",
            "CATEGORIA": "TARIFA PIX",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-5.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Pix Enviado de PJ para PJ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3054",
            "RECONCILIADO": "3054",
            "DATA_RECONCILIADO": "2025-05-03 11:28:49",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "5.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "42344",
            "CATEGORIA_ID": "25",
            "CATEGORIA": "SPLIT TARIFA",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-1.20",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Tarifa Security ",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3056",
            "RECONCILIADO": "3056",
            "DATA_RECONCILIADO": "2025-05-03 11:28:55",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1.20",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "33848",
            "CATEGORIA_ID": "156",
            "CATEGORIA": "MARKETING TRANSPORTE",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "SNS QUIROPRAXIA LTDA",
            "FORNECEDOR_ID": "60",
            "DATA_CADASTRO": "2025-04-29 14:51:55",
            "DATA_VENCIMENTO": "2025-04-26",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "N",
            "VALOR": "99.39",
            "VALOR_DESCONTO": "0.00",
            "VALOR_MULTA": "0.00",
            "RECORRENCIA_ID": "4Lvt0SKKo83jRQziOtYG",
            "RECORRENCIA_TIPO": "M",
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": "100",
            "RECORRENCIA_PARCELA": "1",
            "DESCRICAO": "SNS - TRANSPORTE MKT",
            "PREVISAO": "1",
            "MOVIMENTACAO_ID": "3126",
            "RECONCILIADO": "3126",
            "DATA_RECONCILIADO": "2025-05-03 11:29:50",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1119.78",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "42345",
            "CATEGORIA_ID": "105",
            "CATEGORIA": "TR\u00c1FEGO META",
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": "META FACEBOOK",
            "FORNECEDOR_ID": "58",
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-200.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "RTLFW - ROBO MKT",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3047",
            "RECONCILIADO": "3047",
            "DATA_RECONCILIADO": "2025-05-03 11:30:11",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "200.00",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "58034",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-01 00:00:00",
            "DATA_VENCIMENTO": "2025-04-01",
            "DATA_PAGAMENTO": "2025-04-01 00:00:00",
            "PAGO": "S",
            "VALOR": "-799.21",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3832",
            "RECONCILIADO": "3832",
            "DATA_RECONCILIADO": "2025-05-12 10:31:31",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "799.21",
            "DATA_MOVIMENTACAO": "2025-04-01"
        },
        {
            "ID": "58041",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-08 00:00:00",
            "DATA_VENCIMENTO": "2025-04-08",
            "DATA_PAGAMENTO": "2025-04-08 00:00:00",
            "PAGO": "S",
            "VALOR": "-4601.84",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3982",
            "RECONCILIADO": "3982",
            "DATA_RECONCILIADO": "2025-05-12 10:42:30",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4601.84",
            "DATA_MOVIMENTACAO": "2025-04-08"
        },
        {
            "ID": "58065",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-02 00:00:00",
            "DATA_VENCIMENTO": "2025-04-02",
            "DATA_PAGAMENTO": "2025-04-02 00:00:00",
            "PAGO": "S",
            "VALOR": "-789.12",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3867",
            "RECONCILIADO": "3867",
            "DATA_RECONCILIADO": "2025-05-12 10:55:38",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "789.12",
            "DATA_MOVIMENTACAO": "2025-04-02"
        },
        {
            "ID": "58075",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-04 00:00:00",
            "DATA_VENCIMENTO": "2025-04-04",
            "DATA_PAGAMENTO": "2025-04-04 00:00:00",
            "PAGO": "S",
            "VALOR": "-180.00",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "3884",
            "RECONCILIADO": "3884",
            "DATA_RECONCILIADO": "2025-05-12 10:58:32",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "180.00",
            "DATA_MOVIMENTACAO": "2025-04-04"
        },
        {
            "ID": "58095",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-09 00:00:00",
            "DATA_VENCIMENTO": "2025-04-09",
            "DATA_PAGAMENTO": "2025-04-09 00:00:00",
            "PAGO": "S",
            "VALOR": "-4569.05",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4043",
            "RECONCILIADO": "4043",
            "DATA_RECONCILIADO": "2025-05-12 11:10:31",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "4569.05",
            "DATA_MOVIMENTACAO": "2025-04-09"
        },
        {
            "ID": "58120",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-11 00:00:00",
            "DATA_VENCIMENTO": "2025-04-11",
            "DATA_PAGAMENTO": "2025-04-11 00:00:00",
            "PAGO": "S",
            "VALOR": "-92.17",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4103",
            "RECONCILIADO": "4103",
            "DATA_RECONCILIADO": "2025-05-12 11:16:19",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "92.17",
            "DATA_MOVIMENTACAO": "2025-04-11"
        },
        {
            "ID": "58141",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-23 00:00:00",
            "DATA_VENCIMENTO": "2025-04-23",
            "DATA_PAGAMENTO": "2025-04-23 00:00:00",
            "PAGO": "S",
            "VALOR": "-233.60",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4188",
            "RECONCILIADO": "4188",
            "DATA_RECONCILIADO": "2025-05-12 11:19:17",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "233.60",
            "DATA_MOVIMENTACAO": "2025-04-23"
        },
        {
            "ID": "58158",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-28 00:00:00",
            "DATA_VENCIMENTO": "2025-04-28",
            "DATA_PAGAMENTO": "2025-04-28 00:00:00",
            "PAGO": "S",
            "VALOR": "-65.45",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4231",
            "RECONCILIADO": "4231",
            "DATA_RECONCILIADO": "2025-05-12 11:23:35",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "65.45",
            "DATA_MOVIMENTACAO": "2025-04-28"
        },
        {
            "ID": "58164",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-29 00:00:00",
            "DATA_VENCIMENTO": "2025-04-29",
            "DATA_PAGAMENTO": "2025-04-29 00:00:00",
            "PAGO": "S",
            "VALOR": "-1119.78",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4246",
            "RECONCILIADO": "4246",
            "DATA_RECONCILIADO": "2025-05-12 11:24:22",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1119.78",
            "DATA_MOVIMENTACAO": "2025-04-29"
        },
        {
            "ID": "58176",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-30 00:00:00",
            "DATA_VENCIMENTO": "2025-04-30",
            "DATA_PAGAMENTO": "2025-04-30 00:00:00",
            "PAGO": "S",
            "VALOR": "-1359.45",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4280",
            "RECONCILIADO": "4280",
            "DATA_RECONCILIADO": "2025-05-12 11:26:13",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "1359.45",
            "DATA_MOVIMENTACAO": "2025-04-30"
        },
        {
            "ID": "58195",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-17 00:00:00",
            "DATA_VENCIMENTO": "2025-04-17",
            "DATA_PAGAMENTO": "2025-04-17 00:00:00",
            "PAGO": "S",
            "VALOR": "-139.88",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4140",
            "RECONCILIADO": "4140",
            "DATA_RECONCILIADO": "2025-05-12 11:29:04",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "139.88",
            "DATA_MOVIMENTACAO": "2025-04-17"
        },
        {
            "ID": "58196",
            "CATEGORIA_ID": null,
            "CATEGORIA": null,
            "CENTRO_DE_CUSTO_ID": null,
            "CENTRO_CUSTO": null,
            "FORNECEDOR": null,
            "FORNECEDOR_ID": null,
            "DATA_CADASTRO": "2025-04-17 00:00:00",
            "DATA_VENCIMENTO": "2025-04-17",
            "DATA_PAGAMENTO": "2025-04-17 00:00:00",
            "PAGO": "S",
            "VALOR": "-83.96",
            "VALOR_DESCONTO": null,
            "VALOR_MULTA": null,
            "RECORRENCIA_ID": null,
            "RECORRENCIA_TIPO": null,
            "RECORRENCIA_VALOR": null,
            "RECORRENCIA_QTD": null,
            "RECORRENCIA_PARCELA": null,
            "DESCRICAO": "Cr\u00e9dito Transfer\u00eancia 70171897 - RTLFW CLINICA DE QUIR",
            "PREVISAO": "0",
            "MOVIMENTACAO_ID": "4139",
            "RECONCILIADO": "4139",
            "DATA_RECONCILIADO": "2025-05-12 11:29:12",
            "CONCILIADO_POR": "saraoliveira",
            "VALOR_CONCILIADO": "83.96",
            "DATA_MOVIMENTACAO": "2025-04-17"
        }
    ],
    "total": 0,
    "paymentStartDate": "2025-04-01",
    "paymentEndDate": "2025-04-30",
    "totalExpenses": null
}`);

const FinancialMonthClosing = ({ data }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const formatDate = (dateString) => {
    return moment(dateString).tz('America/Sao_Paulo').format('DD/MM/YYYY');
  };

  const [openExpenseCategories, setOpenExpenseCategories] = React.useState({});
  const [openRevenueCategories, setOpenRevenueCategories] = React.useState({});

  const toggleExpenseCategory = (category) => {
    setOpenExpenseCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const toggleRevenueCategory = (category) => {
    setOpenRevenueCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  /*React.useEffect(() => {
    if (data.expenses.items.length > 0) {
      console.log('baseComparation', baseComparation);
      let sumTotal = 0;
      let sumTotalExists = 0;
      data.expenses.items.forEach(item => {
        if (item.ITENS.length > 0) {
          item.ITENS.forEach(itemItens => {
            // check if item.RECONCILIADO exists in baseComparation 
            
            const exists = baseComparation.data.find(item2 => parseInt(itemItens.MOVIMENTACAO_ID) === parseInt(item2.MOVIMENTACAO_ID));
            console.log('itemItens', itemItens, exists);
            if (exists) {
              sumTotalExists = sumTotalExists + 1;
            }
            sumTotal = sumTotal + 1;
          });
        }
      });
      console.log('sumTotal', sumTotal);
      console.log('sumTotalExists', sumTotalExists);
    }
  }, [data]);*/

  React.useEffect(() => {
    window.reloadIconss();
  }, []);

  return (
    <div className="container-fluid py-4">
      {/* Cabeçalho do Relatório */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Relatório de Fechamento Mensal</h4>
          <small>
            Período: {formatDate(data.period.start_date)} até {formatDate(data.period.end_date)}
          </small>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-auto text-center mb-3">
              <div className="h6">Receita bruta <i className="fa fa-info-circle" data-tip="Receita bruta é o total de receitas lançadas na tela 'Vendas' do sistema."></i></div>
              <div className="h4 text-success">{formatCurrency(data.revenue.total)}</div>
            </div>
            <div className="col-auto text-center mb-3">
              <div className="h6">Despesas <i className="fa fa-info-circle" data-tip="Despesas é o total de despesas lançadas na tela 'Contas a pagar' do sistema."></i></div>
              <div className="h4 text-danger">{formatCurrency(data.expenses.total)}</div>
            </div>
            <div className="col-auto text-center mb-3">
              <div className="h6">Impostos <i className="fa fa-info-circle" data-tip="Impostos é 10% sobre a receita bruta."></i></div>
              <div className="h4 text-danger">{formatCurrency(data.summary.total_taxes_upon_revenue)}</div>
            </div>
            <div className="col-auto text-center mb-3">
                <div className="h6">Taxas ValoriBank <i className="fa fa-info-circle" data-tip="Taxas são referentes a recebimentos da ValoriBank."></i></div>
                <div className="h4 text-danger">{formatCurrency(data.revenue.total_taxes)}</div>
            </div>
            <div className="col-auto text-center mb-3">
              <div className="h6">Resultado Liquído <i className="fa fa-info-circle" data-tip="Resultado é a diferença entre a receita bruta e as despesas."></i></div>
              <div className="h4 text-primary">{formatCurrency(data.summary.total_profit)}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Seção de Despesas */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header bg-danger text-white">
          <h5 className="mb-0">Despesas</h5>
        </div>
        <div className="card-body">
          {data.expenses.items.map((categoria, index) => (
            <div key={index} className="mb-3">
              <div className="d-flex justify-content-between align-items-center p-3 bg-light rounded">
                <div>
                  <h6 className="mb-0 text-dark">{categoria.CATEGORIA}</h6>
                  <small className="text-muted">Quantidade: {categoria.QUANTIDADE}</small>
                </div>
                <div className="d-flex align-items-center">
                  <h5 className="mb-0 me-3 text-danger">{formatCurrency(categoria.TOTAL_PAGO)}</h5>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => toggleExpenseCategory(categoria.CATEGORIA)}
                  >
                    <i className="bi bi-chevron-down"></i> {openExpenseCategories[categoria.CATEGORIA] ? 'Ocultar' : 'Detalhes'}
                  </button>
                </div>
              </div>
              
              <div className={openExpenseCategories[categoria.CATEGORIA] ? '' : 'd-none'}>
                <table className="table table-striped table-hover mt-2">
                  <thead>
                    <tr>
                      <th>N° da movimentação</th>
                      <th>N° da conta a pagar</th>
                      <th>Data Movimentação</th>
                      <th>Filial</th>
                      <th>Descrição</th>
                      <th>Valor</th>
                      <th>Conciliado por</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoria.ITENS.map((item) => (
                      <tr key={item.ID}>
                        <td>{item.MOVIMENTACAO_ID}</td>
                        <td>{item.ID}</td>
                        <td>{formatDate(item.DATA_PAGAMENTO)}</td>
                        <td>{item.FILIAL}</td>
                        <td>{item.DESCRICAO}</td>
                        <td className="text-danger">{formatCurrency(Math.abs(item.VALOR))}</td>
                        <td>{item.CONCILIADO_POR}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Seção de Receitas */}
      <div className="card shadow-sm">
        <div className="card-header bg-success text-white">
          <h5 className="mb-0">Receitas</h5>
        </div>
        <div className="card-body">
          {data.revenue.items.map((categoria, index) => (
            <div key={index} className="mb-3">
              <div className="d-flex justify-content-between align-items-center p-3 bg-light rounded">
                <div>
                  <h6 className="mb-0 text-dark">{categoria.CATEGORIA}</h6>
                  <small className="text-muted">Quantidade: {categoria.QUANTIDADE}</small>
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-end me-3">
                    <div className="h5 mb-0 text-success">{formatCurrency(categoria.VALOR_TOTAL)}</div>
                    <small className="text-muted">Taxas: {formatCurrency(categoria.VALOR_TOTAL_TAXAS)}</small>
                  </div>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => toggleRevenueCategory(categoria.CATEGORIA)}
                  >
                    <i className="bi bi-chevron-down"></i> {openRevenueCategories[categoria.CATEGORIA] ? 'Ocultar' : 'Detalhes'}
                  </button>
                </div>
              </div>

              <div className={openRevenueCategories[categoria.CATEGORIA] ? '' : 'd-none'}>
                <table className="table table-striped table-hover mt-2">
                  <thead>
                    <tr>
                      <th>N° da movimentação</th>
                      <th>Data Recebimento</th>
                      <th>Filial</th>
                      <th>Descrição</th>
                      <th>Valor taxa</th>
                      <th>Valor recebido</th>
                      <th>Conciliado por</th>
                      <th>Data Conciliação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoria.ITENS.map((item) => (
                      <tr key={item.ID}>
                        <td>{item.MOVIMENTACAO_ID}</td>
                        <td>{formatDate(item.DATA_RECEBIMENTO)}</td>
                        <td>{item.FILIAL}</td>
                        <td>{item.DESCRICAO}</td>
                        <td className="text-danger">{formatCurrency(item.VALOR_TAXA)}</td>
                        <td className="text-success">{formatCurrency(item.VALOR_CONCILIADO)}</td>
                        <td>{item.CONCILIADO_POR}</td>
                        <td>{formatDate(item.DATA_RECONCILIACAO)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="4">Total</td>
                      <td>{formatCurrency(categoria.VALOR_TOTAL_TAXAS)}</td>
                      <td>{formatCurrency(categoria.VALOR_TOTAL)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialMonthClosing; 